import { z } from "zod"

export const E2E_TOKEN_ISSUER = "e2e-test"

export const SetPackageMaterialCostSchema = z.object({
  packageName: z.string().min(1),
  includedMaterialCost: z.number().int().nullable(),
})

export type SetPackageMaterialCostBody = z.infer<
  typeof SetPackageMaterialCostSchema
>
